import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  Switch,
  FormControlLabel
} from "@mui/material";
import { useState, useEffect } from "react";

export default function ConfigRestaurante({ state, open, onClose }) {
  const [config, setConfig] = useState(state.config);

  useEffect(() => {
    setConfig(state.config);
  }, [state.config, open]);

  const guardar = () => {
    state.actualizarConfig(config);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Configuración del Restaurante</DialogTitle>

      <DialogContent sx={{ mt: 1 }}>
        <Stack spacing={3}>
          <TextField
            label="Nombre del negocio"
            value={config.nombreNegocio}
            onChange={e =>
              setConfig({ ...config, nombreNegocio: e.target.value })
            }
          />

          <TextField
            label="Moneda"
            value={config.moneda}
            onChange={e =>
              setConfig({ ...config, moneda: e.target.value })
            }
            helperText="Ej: BOB, Bs, USD"
          />

          <FormControlLabel
            control={
              <Switch
                checked={config.imprimeTicket}
                onChange={e =>
                  setConfig({ ...config, imprimeTicket: e.target.checked })
                }
              />
            }
            label="Imprimir ticket al cobrar"
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={guardar}>
          Guardar cambios
        </Button>
      </DialogActions>
    </Dialog>
  );
}
